import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageShell } from "@/components/marketing/PageShell";
import { ARTICLES } from "@/data/blog";

const CATEGORIES = ["All", ...new Set(ARTICLES.map((a) => a.category))];
const slugify = (s) => s.toLowerCase().replace(/[^a-z]+/g, "-");

const Card = ({ a, big }) => (
  <Link to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`}
    className={`group flex flex-col overflow-hidden rounded-3xl border border-gray-200 bg-white transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/5 ${big ? "md:col-span-2 md:flex-row" : ""}`}>
    <div className={`overflow-hidden bg-gray-100 ${big ? "md:w-3/5" : ""}`}>
      <img src={a.image} alt="" loading="lazy" className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${big ? "h-56 md:h-full" : "h-48"}`} />
    </div>
    <div className={`flex flex-1 flex-col p-6 ${big ? "md:justify-center md:p-10" : ""}`}>
      <span className="font-mono-label text-[9px] font-semibold text-oath-accent">{a.category.toUpperCase()}</span>
      <h2 className={`mt-2 font-display font-bold leading-snug text-oath-ink ${big ? "text-2xl" : "text-lg"}`}>{a.title}</h2>
      <p className="mt-2 text-sm leading-relaxed text-oath-secondary">{a.excerpt}</p>
      <span className="mt-auto inline-flex items-center gap-1 pt-4 font-mono-label text-[10px] font-semibold text-oath-ink">READ <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></span>
    </div>
  </Link>
);

export default function Blog() {
  const [cat, setCat] = useState("All");
  const list = cat === "All" ? ARTICLES : ARTICLES.filter((a) => a.category === cat);
  return (
    <PageShell eyebrow="— INSIGHTS —" title="The ResidenceProof Blog">
      <p className="max-w-2xl text-sm text-oath-secondary">Guides and explainers on address, occupancy and household verification for insurers, lenders and benefit programs.</p>
      <div className="mt-8 flex flex-wrap gap-2" data-testid="blog-filters">
        {CATEGORIES.map((c) => (
          <button key={c} onClick={() => setCat(c)} data-testid={`blog-filter-${slugify(c)}`}
            className={`rounded-full border px-4 py-2 font-mono-label text-[10px] font-semibold transition-colors ${cat === c ? "border-oath-ink bg-oath-ink text-white" : "border-gray-200 bg-white text-oath-secondary hover:text-oath-ink"}`}>{c.toUpperCase()}</button>
        ))}
      </div>
      <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-testid="blog-grid">
        {list.map((a, i) => <Card key={a.slug} a={a} big={i === 0 && cat === "All"} />)}
      </div>
    </PageShell>
  );
}
